import { getIntDate } from '@/views/analysis/common.js'
export default {
  titleTxt: [
    {
      title: '核心指标',
      tipTxt: '您可以查看选定的查询条件和时间周期下的核心指标，以及与上一时间周期的对比情况。其中，<br />费用成本（元）：即搜索信息流花费+品牌广告花费+合作价格<br />内容数：即笔记或文章数量<br />创作人数：即创作者或达人数量，需按昵称去重<br />声量：即互动量<br />CPE：即互动量 / 费用成本，按天取均值<br />CPV：即阅读量 / 费用成本，按天取均值<br />爆款率：即爆文的内容数 / 内容数'
    },
    {
      title: '声量趋势',
      tipTxt: '按天或按月展现声量变化趋势，您可以添加自己和竞品的平台指数，进行对比分析。'
    },
    {
      title: '产线分析',
      tipTxt: '您可以了解各产线核心指标的数据情况。'
    }
  ],
  filterAjaxList: [
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brand',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/line/label',
      method: 'get',
      flagKey: 'lineName',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/platform/label',
      method: 'post',
      param: {},
      flagKey: 'platform',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/is/prereport/label',
      method: 'get',
      flagKey: 'isPrereport',
      id: 'name',
      name: 'name'
    }
  ],
  filterForm: [
    {
      type: 'select',
      clearable: true,
      id: 'platform',
      label: '平台',
      width: '200px',
      intintValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'brand',
      label: '品牌',
      width: '200px',
      intValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'lineName',
      label: '产线',
      placeholder: '综合',
      width: '200px',
      intintValue: '',
      children: []
    },
    {
      type: 'select',
      id: 'isPrereport',
      label: '是否报备',
      placeholder: '全部',
      width: '200px',
      intintValue: '',
      children: []
    },
    {
      type: 'tab',
      id: 'timeType',
      label: '选择时间',
      intValue: '0',
      children: [{
        id: '0',
        name: '月报',
        showItemId: 'dateMonth',
        hideItemId: 'dateTime'
      }, {
        id: '1',
        name: '日报',
        showItemId: 'dateTime',
        hideItemId: 'dateMonth'
      }]
    }, {
      type: 'month',
      isHide: false,
      format: 'yyyy年 MM月',
      valueFormat: 'yyyy-MM',
      clearable: true,
      id: 'dateMonth',
      label: '',
      width: '160px',
      intValue: getIntDate()
    }, {
      type: 'datesRange',
      dateType: 'date',
      isHide: true,
      clearable: true,
      id: 'dateTime',
      startTimeId: 'dateTimeStartTime',
      endTimeId: 'dateTimeEndTime',
      label: '',
      width: '390px'
    }
  ],
  formRules: {
    brand: [
      {
        required: true,
        message: '请选择'
      }
    ]
  },
  // 核心指标
  indicatorsList: [
    {
      imgIcon: require('@/assets/images/core-indicators/chengben.png'),
      name: '费用成本(元)',
      sumKey: 'totalCost',
      sum: '',
      rateKey: 'totalCostLrr',
      rate: ''
    }, {
      imgIcon: require('@/assets/images/core-indicators/chuangzuo.png'),
      name: '内容数',
      sumKey: 'contentCnt',
      sum: '',
      rateKey: 'contentCntLrr',
      rate: ''
    }, {
      imgIcon: require('@/assets/images/core-indicators/ren.png'),
      name: '创作人数',
      sumKey: 'creatorCnt',
      sum: '',
      rateKey: 'creatorCntLrr',
      rate: ''
    }, {
      imgIcon: require('@/assets/images/core-indicators/shengliang.png'),
      name: '互动量',
      sumKey: 'interactNum',
      sum: '',
      rateKey: 'interactNumLrr',
      rate: ''
    },
    {
      imgIcon: require('@/assets/images/core-indicators/cpe.png'),
      name: 'CPE(元)',
      sumKey: 'cpeCost',
      sum: '',
      rateKey: 'cpeCostLrr',
      rate: ''
    }, {
      imgIcon: require('@/assets/images/core-indicators/cpm.png'),
      name: 'CPV(元)',
      sumKey: 'cpvCost',
      sum: '',
      rateKey: 'cpvCostLrr',
      rate: ''
    }, {
      imgIcon: require('@/assets/images/core-indicators/baokuan.png'),
      name: '爆款率',
      sumKey: 'popularRatio',
      sum: '',
      rateKey: 'popularRatioLrr',
      rate: ''
    },
    {
      imgIcon: require('@/assets/images/core-indicators/youli.png'),
      name: '声量指数(品牌搜索指数)',
      sumKey: 'searchIndex',
      sum: '',
      rateKey: 'searchIndexLrr',
      rate: ''
    }
  ],
  // 声量趋势
  volumnFormArr: [
    {
      type: 'radio',
      id: 'selectType',
      label: '指标',
      width: '400px',
      intValue: '1',
      children: [{
        id: '1',
        name: '内容数'
      }, {
        id: '2',
        name: '互动量'
      }]
    }, {
      type: 'tree',
      multiple: true,
      id: 'searchStr',
      label: '加入对比',
      width: '500px',
      clearable: true,
      intValue: [['品牌搜索指数', '方太']],
      children: [{
        id: '品牌搜索指数',
        name: '品牌搜索指数',
        children: []
      }, {
        id: '小红书指数',
        name: '小红书指数',
        children: []
      }]
    }
  ],
  volumnSeriesData: [
    {
      name: '内容数',
      type: 'line',
      key: 'dataCountExtra',
      data: [],
      itemColor: '#326CFA',
      unit: ''
    }
  ],
  sortRules: [{
    name: '降序',
    id: '1'
  }, {
    name: '升序',
    id: '2'
  }],
  // 产线分析数据 - 表头
  tableHead: [
    {
      label: '序号',
      key: '$index',
      width: '80',
      fixed: true
    }, {
      label: '产线',
      key: 'lineName',
      width: 200,
      fixed: true
    }, {
      label: '费用成本(元)',
      key: 'totalCost',
      txtAlign: 'right',
      rightWidth: '180px'
    }, {
      label: '搜索信息流花费(元)',
      key: 'searchCost',
      txtAlign: 'right',
      rightWidth: 180
    }, {
      label: '品牌广告花费(元)',
      key: 'brandAdCost',
      txtAlign: 'right',
      rightWidth: 180
    }, {
      label: '合作价格(元)',
      key: 'cooperateCost',
      txtAlign: 'right',
      rightWidth: '180px'
    }, {
      label: '创作人数',
      key: 'creatorCnt',
      txtAlign: 'right'
    }, {
      label: '内容数',
      key: 'contentCnt',
      txtAlign: 'right'
    }, {
      label: '爆款量',
      key: 'popularNum',
      txtAlign: 'right'
    }, {
      label: '爆款率',
      key: 'popularRatio',
      txtAlign: 'right'
    }, {
      label: '曝光数',
      key: 'exposeNum',
      txtAlign: 'right'
    }, {
      label: '阅读量',
      key: 'readNum',
      txtAlign: 'right'
    }, {
      label: '点赞数',
      key: 'likeNum',
      txtAlign: 'right'
    }, {
      label: '收藏数',
      key: 'subscribeNum',
      txtAlign: 'right'
    }, {
      label: '评论数',
      key: 'commentNum',
      txtAlign: 'right'
    }, {
      label: '互动量',
      key: 'interactNum',
      txtAlign: 'right'
    }, {
      label: '互动率',
      key: 'interactRate',
      txtAlign: 'right'
    }, {
      label: '平均互动量',
      key: 'interactNumAvg',
      txtAlign: 'right'
    },
    // {
    //   label: '互动成本(元)',
    //   key: 'interactCost',
    //   txtAlign: 'right',
    //   rightWidth: '120px'
    // },
    {
      label: 'CPE(元)',
      key: 'cpeCost',
      txtAlign: 'right'
    },
    {
      label: 'CPV(元)',
      key: 'cpvCost',
      txtAlign: 'right'
    }
  ]
}
